import { SelectOption } from "@/flokit/compound/inputs/select/base";

type BaseFieldDisplayProps = {
  label?: string;
  description?: string;
  section?: string;
  showBorder?: boolean;
  children?: React.ReactNode;
};

export const BaseFieldDisplay = (props: BaseFieldDisplayProps) => {
  return (
    <div className="flex flex-col gap-y-2">
      <div className="flex flex-col">
        {props.section ? (
          <p className="text-medium-hippo text-sm">{props.section}</p>
        ) : null}
        {props.label ? (
          <p className="pt-2 text-base font-semibold">{props.label}</p>
        ) : null}
        {props.description ? (
          <p
            className="whitespace-prewrap pb-1 pt-1 text-base leading-normal"
            dangerouslySetInnerHTML={{
              __html: props.description,
            }}
          />
        ) : null}
      </div>
      {props.children ? props.children : null}
      {props.showBorder ? (
        <div className="border-dublin-gray mt-6 border-t pb-3" />
      ) : null}
    </div>
  );
};

{
  /* <ul className="text-sm text-medium-hippo flex list-disc flex-col gap-y-1.5 pl-4 pt-2">
        {props.options.map((option) => {
          return <li key={option.value}>{option.label}</li>;
        })}
      </ul> */
}
export const SelectFieldDisplay = (
  props: Omit<BaseFieldDisplayProps, "children"> & {
    options: SelectOption[];
  },
) => {
  return (
    <BaseFieldDisplay {...props}>
      <ul className="text-medium-hippo flex list-disc flex-col gap-y-1.5 pl-4 pt-2 text-sm">
        {props.options.map((option) => {
          return <li key={option.value}>{option.label}</li>;
        })}
      </ul>
    </BaseFieldDisplay>
  );
};
